/** UUIDv7 generowany po stronie klienta albo serwera. */
export type Id = string;

/** Hybrid Logical Clock w postaci tekstu sortowalnego leksykograficznie (patrz sync/hlc.ts). */
export type Hlc = string;

/** Status pozycji na liście zakupów. */
export type ItemStatus = 'pending' | 'cart' | 'missing' | 'partial' | 'substitute';

/** Statusy oznaczające, że użytkownik był przy półce z produktem. */
export const VISITED_STATUSES: readonly ItemStatus[] = ['cart', 'missing', 'partial', 'substitute'];
